import * as angular from 'angular';

import controller, { PlatformHeaderStyle } from './platform-header-controller';

const PlatformHeaderComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    headerStyle: '@',
    menuType: '@',
    onSimpleShare: '&?',
    navPanelEnabled: '<?',
    standaloneEnabled: '<?',
    isLocal: '<?',
    pageContext: '<?',
    isNewDataset: '<?',
  },
  template: `
    <div ng-class="ctrl.getHeaderClasses()" class="platform-header">

      <!-- Header Wrapper Begins -->
      <div class="mode-header-component" ng-class="{'explore': ctrl.showExploreHeader()}">

        <!-- Logo Begins -->
        <nav-flyout
          ng-if="(ctrl.isLoggedIn$ | async:this) && (ctrl.accountContext$ | async:this)"
          theme="ctrl.headerStyle === '${PlatformHeaderStyle.Dark}' ? 'dark' : 'light'"
        ></nav-flyout>
        <div
          ng-if="!(ctrl.isLoggedIn$ | async:this)">
          <a href="/" class="mode-header-logo dark-sidebar" target="_self">
            <i class="icon-logo" aria-hidden="true"></i>
            <span class="visually-hidden">Home<span>
          </a>
        </div>
        <!-- @Logo Ends -->

        <!-- Default Content Container -->
        <div class="platform-header-default-content-container" ng-if="!ctrl.navPanelEnabled"></div>

        <platform-header-nav-panel
          ng-if="ctrl.navPanelEnabled"
          nav-display-mode="ctrl.navDisplayMode"
          menu-type="ctrl.menuType"
          breakpoint="ctrl._breakpoint"
          on-simple-share="ctrl.handleSimpleShare()"
          edit-access="ctrl.editAccess$ | async:this"
          is-local="ctrl.isLocal"
          is-new-dataset="ctrl.isNewDataset"
          />

        <div class="platform-header-tool-panel" ng-if='!ctrl.isExploreRoute()' ng-class="{'analyst-studio': (ctrl.isAnalystStudio$ | async:this)}">
          <user-access-avatar
            ng-if="ctrl.showUserAccessAvatar()"
            [avatar]="ctrl.avatar"
            [edit-access]="ctrl.editAccess$ | async:this"
          ></user-access-avatar>
          
          <div ng-if="(ctrl.accountContext$ | async:this) && (ctrl.accountContext$ | async:this).user === false"
            class="platform-header-search-container"
          >
            <mode-header-search
              [display]="ctrl.headerStyle === '${PlatformHeaderStyle.Dark}' ? 'button' : 'bar'"
              [theme]="ctrl.headerStyle === '${PlatformHeaderStyle.Dark}' ? 'dark' : 'light'"
            ></mode-header-search>
          </div>

          <!-- New Report Trigger Begins -->
          <mode-report-creation-menu
            ng-if="!ctrl.isExploreRoute() && (ctrl.isLoggedIn$ | async:this) === true"
            [query-metrics-enabled]="ctrl.queryMetricsEnabled$ | async:this"
            [org]="(ctrl.orgContext$ | async:this).username"
            [theme]="ctrl.headerStyle === '${PlatformHeaderStyle.Dark}' ? 'dark' : 'light'">
          </mode-report-creation-menu>

          <!-- @New Report Trigger Ends -->

          <div class="header-item-wrapper" ng-if="(ctrl.isLoggedIn$ | async:this) === false">
            <a href="/signup" class="btn btn-primary header-item-content" target="_self">
              Sign Up
            </a>
          </div>

          <div class="header-item-wrapper header-item-content" ng-if="(ctrl.isLoggedIn$ | async:this) === false">
           <a href="/signin" class="nav-link nav-link-contrast header-item-content" target="_self">
              Sign In
            </a>
          </div>

          <mode-help-menu
            class="help-menu-component"
            [is-guest]="(ctrl.isLoggedIn$ | async:this) === false"
            [is-community]="(ctrl.accountContext$ | async:this).user"
            [theme]="ctrl.headerStyle === '${PlatformHeaderStyle.Dark}' ? 'dark' : 'light'"
            [intercom-chat-enabled]="ctrl.intercomChatEnabled$ | async:this"
          ></mode-help-menu>
          <mode-trial-banner
            [billing-link]="(ctrl.accountContext$ | async:this).billingLink"
            [user-email]="(ctrl.account$ | async:this).email"
            [user-display-name]="(ctrl.account$ | async:this).displayName"
            ></mode-trial-banner>
          <mode-studio
            ng-if="ctrl.showModeStudio$ | async:this"
            [org-username]="(ctrl.orgContext$ | async:this).username"
            [theme]="ctrl.getStudioBadgeTheme()"
          ></mode-studio>
        </div>
      </div>
      <!-- @Header Wrapper Ends -->

    </div>
  `,
};

export { PlatformHeaderComponent };

// @todo remove by registering explicitly at the application/module level for portability
angular.module('mode.components').component('platformHeader', PlatformHeaderComponent);
